<template>
  <div class="card">
    <div class="flex-column">
      <div class="title">{{ title }}</div>
      <el-divider/>
      <div class="tip">{{ tip }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CompCard',
  data() {
    return {};
  },
  props: {
    title: String,
    tip: {
      type: [String, Number],
      default: '',
    }
  },
}
</script>

<style lang="less" scoped>
.card {
  width: 230px;
  height: 150px;
  padding: 10px;
  background-color: #FFFFFF;
  border: 1px solid #f1f1f1;

  .title {
    font-size: 18px;
    font-weight: 600;
    color: #5a9ade;
    text-align: center;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }

  .tip {
    font-size: 14px;
    line-height: 1.5;
  }

}
</style>
